export default __webpack_public_path__ + "static/media/google.4e4e2945.png";